<template>
    <div class="pageManager-m">
        <div class="jobMain">
            <div class="manager-rig">
                <div class="manager-rt">
                    <div class="manager-rtle">数据统计</div>
                </div>
                <div class="manager-rm" v-for="(item, index) in countData" :key="item.YEAR">
                    <div class="manager-rmt clearfix">
                        <span class="manager-rmt-title">{{ item.YEAR }}年度数据统计<span class="manager-rmsubt">数据截止 {{ dataCutoffText }}</span></span>
                        <el-button
                            class="manager-rmt-export"
                            type="danger"
                            size="small"
                            plain
                            :loading="exportingIndex === index"
                            :disabled="exportingIndex !== null"
                            @click="exportYearApplicants(index)">
                            <i v-if="exportingIndex !== index" class="el-icon-download"></i>
                            {{ exportingIndex === index ? '正在导出...' : ('导出' + item.YEAR + '考生信息') }}
                        </el-button>
                    </div>
                    <div class="manager-rmb">
                        <el-row>
                            <el-col :span="4">
                                <div class="manager-tjbox">
                                    <div><i class="el-icon-user ficon blue"></i></div>
                                    <div class="tjSubtle">总报名人数</div>
                                    <div class="tjNum">{{ item.totalApplications }}</div>
                                </div>
                            </el-col>
                            <el-col :span="4">
                                <div class="manager-tjbox">
                                    <div><i class="el-icon-document-remove ficon yellow"></i></div>
                                    <div class="tjSubtle">待审核人数</div>
                                    <div class="tjNum">{{ item.pendingApplications }}</div>
                                </div>
                            </el-col>
                            <el-col :span="4">
                                <div class="manager-tjbox manager-tjbox--reviewed">
                                    <div class="tjReviewedMain">
                                        <div class="tjReviewedLeft">
                                            <div><i class="el-icon-document-checked ficon green"></i></div>
                                            <div class="tjSubtle">已审核人数</div>
                                            <div class="tjNum">{{ item.reviewedApplications }}</div>
                                        </div>
                                        <div class="tjBreakdown">
                                            <span>已通过人数 {{ item.approvedApplications }}</span>
                                            <span>未通过人数 {{ item.rejectedApplications }}</span>
                                            <span>待补充资料 {{ item.pendingSupplementApplications }}</span>
                                        </div>
                                    </div>
                                </div>
                            </el-col>
                            <el-col :span="4">
                                <div class="manager-tjbox">
                                    <div><i class="el-icon-edit-outline ficon yellow"></i></div>
                                    <div class="tjSubtle">待签名人数</div>
                                    <div class="tjNum">{{ item.pendingSignatureApplications }}</div>
                                </div>
                            </el-col>
                            <el-col :span="8">
                                <div class="manager-tjbox1">
                                    <div :ref="'checkChart' + index" style="width: 100%; height: 200px"></div>
                                </div>
                            </el-col>
                        </el-row>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
import Cookies from "js-cookie";
import axios from "axios";
import * as echarts from 'echarts';
import { downloadYearApplicantsExcelBlob, parseContentDispositionFileName, parseJsonBlobError } from '../utils/applicationYearExport';

const SYSTEM_START_YEAR = 2026;

export default {
    name: 'PageRegNotes',
    data() {
        return {
            countData: [],
            chartInstances: [],
            exportingIndex: null,
            dataCutoffText: '',
        }
    },
    created() {
        this.dataCutoffText = this.$moment().format('YYYY年M月D日 HH:mm:ss');
        this.countData = this.buildDefaultCountData();
    },
    mounted() {
        document.title = '潞安招聘-数据统计';
        this.$nextTick(() => {
            this.initCharts();
            this.getCount();
        });
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.handleChartResize);
        this.disposeCharts();
    },
    methods: {
        getDisplayYears() {
            const currentYear = new Date().getFullYear();
            const startYear = Math.max(SYSTEM_START_YEAR, currentYear - 2);
            const years = [];
            for (let year = currentYear; year >= startYear; year--) {
                years.push(year);
            }
            return years;
        },
        handleChartResize() {
            this.chartInstances.forEach((chart) => {
                if (chart) {
                    chart.resize();
                }
            });
        },
        buildDefaultCountData() {
            return this.getDisplayYears().map((year) => ({
                pendingApplications: 0,
                rejectedApplications: 0,
                approvedApplications: 0,
                pendingSupplementApplications: 0,
                pendingSignatureApplications: 0,
                YEAR: year,
                totalApplications: 0,
                reviewedApplications: 0,
            }));
        },
        buildChartOption(item) {
            return {
                title: { text: '数据分布' },
                tooltip: { trigger: 'axis', axisPointer: { type: 'shadow' } },
                label: { show: true, position: 'top', color: '#000' },
                grid: { left: '20%', right: '10%', bottom: '20%', top: '25%' },
                xAxis: { type: 'category', boundaryGap: true, data: ['总报名', '待审核', '已审核', '待签名'] },
                yAxis: { type: 'value', splitLine: { show: true, lineStyle: { color: '#f2f2f2', type: 'solid' } } },
                series: [
                    {
                        name: '数据分布',
                        type: 'bar',
                        barWidth: 20,
                        data: [
                            Number(item.totalApplications) || 0,
                            Number(item.pendingApplications) || 0,
                            Number(item.reviewedApplications) || 0,
                            Number(item.pendingSignatureApplications) || 0,
                        ],
                        itemStyle: {
                            normal: {
                                color: function (params) {
                                    const colorList = ['#409EFF', '#E6A23C', '#67C23A', '#909399'];
                                    return colorList[params.dataIndex];
                                },
                            },
                        },
                    },
                ],
            };
        },
        disposeCharts() {
            this.chartInstances.forEach((chart) => {
                if (chart) {
                    chart.dispose();
                }
            });
            this.chartInstances = [];
        },
        initCharts() {
            this.disposeCharts();
            this.countData.forEach((item, index) => {
                const refs = this.$refs['checkChart' + index];
                const el = Array.isArray(refs) ? refs[0] : refs;
                if (el) {
                    const chart = echarts.init(el);
                    chart.setOption(this.buildChartOption(item), true);
                    this.chartInstances.push(chart);
                }
            });
            window.removeEventListener('resize', this.handleChartResize);
            window.addEventListener('resize', this.handleChartResize);
        },
        normalizeYear(item) {
            if (!item) {
                return null;
            }
            return item.YEAR != null ? item.YEAR : item.year;
        },
        pickStatNumber(item, ...keys) {
            if (!item) {
                return 0;
            }
            for (let i = 0; i < keys.length; i++) {
                const val = item[keys[i]];
                if (val != null && val !== '') {
                    return Number(val) || 0;
                }
            }
            const lowerKeys = keys.map((k) => String(k).toLowerCase());
            const entries = Object.keys(item);
            for (let j = 0; j < entries.length; j++) {
                const key = entries[j];
                if (lowerKeys.indexOf(String(key).toLowerCase()) !== -1) {
                    const val = item[key];
                    if (val != null && val !== '') {
                        return Number(val) || 0;
                    }
                }
            }
            return 0;
        },
        normalizeStatItem(item) {
            if (!item) {
                return null;
            }
            return {
                YEAR: this.normalizeYear(item),
                totalApplications: this.pickStatNumber(item, 'totalApplications', 'total_applications'),
                pendingApplications: this.pickStatNumber(item, 'pendingApplications', 'pending_applications'),
                reviewedApplications: this.pickStatNumber(item, 'reviewedApplications', 'reviewed_applications'),
                approvedApplications: this.pickStatNumber(item, 'approvedApplications', 'approved_applications'),
                rejectedApplications: this.pickStatNumber(item, 'rejectedApplications', 'rejected_applications'),
                pendingSupplementApplications: this.pickStatNumber(item, 'pendingSupplementApplications', 'pending_supplement_applications'),
                pendingSignatureApplications: this.pickStatNumber(item, 'pendingSignatureApplications', 'pending_signature_applications'),
            };
        },
        applyCountData(apiData) {
            const defaults = this.buildDefaultCountData();
            const list = Array.isArray(apiData) ? apiData : [];
            this.countData = defaults.map((defaultItem) => {
                const matched = list.find((item) => Number(this.normalizeYear(item)) === Number(defaultItem.YEAR));
                if (!matched) {
                    return defaultItem;
                }
                const normalized = this.normalizeStatItem(matched);
                return Object.assign({}, defaultItem, normalized, {
                    YEAR: normalized.YEAR != null ? normalized.YEAR : defaultItem.YEAR,
                });
            });
            this.$nextTick(() => {
                this.initCharts();
            });
        },
        getCount: function () {
            const token = Cookies.get('reqToKen');
            axios.get('/zhaopinapi/job-applications/statistics/year', {
                headers: token ? { Authorization: token } : {},
            }).then((res) => {
                const _d = res.data;
                if (_d.success) {
                    this.applyCountData(_d.data);
                } else {
                    this.applyCountData([]);
                }
            }).catch((error) => {
                console.log(error);
                this.applyCountData([]);
            });
        },
        exportYearApplicants(index) {
            if (this.exportingIndex !== null) {
                return;
            }
            const yearItem = this.countData[index];
            const year = yearItem && yearItem.YEAR != null ? Number(yearItem.YEAR) : null;
            if (!year) {
                this.$message.error('年份无效');
                return;
            }
            this.exportingIndex = index;
            axios.get('/zhaopinapi/job-applications/export/year', {
                responseType: 'blob',
                params: { year },
                timeout: 600000,
            }).then(async (res) => {
                const contentType = (res.headers['content-type'] || '').toLowerCase();
                if (contentType.indexOf('application/json') !== -1) {
                    const _d = await parseJsonBlobError(res.data);
                    this.$message.error((_d && _d.message) || '导出失败');
                    return;
                }
                const fallbackName = `${year}考生信息.xlsx`;
                const fileName = parseContentDispositionFileName(res.headers['content-disposition'], fallbackName);
                downloadYearApplicantsExcelBlob(res.data, fileName);
                this.$message.success(`导出成功：${fileName}`);
            }).catch(async (error) => {
                console.log(error);
                const blob = error.response && error.response.data;
                if (blob instanceof Blob && (blob.type || '').indexOf('json') !== -1) {
                    try {
                        const _d = await parseJsonBlobError(blob);
                        this.$message.error((_d && _d.message) || '导出失败，请稍后重试');
                        return;
                    } catch (parseError) {
                        console.log(parseError);
                    }
                }
                this.$message.error('导出失败，请稍后重试');
            }).finally(() => {
                this.exportingIndex = null;
            });
        },
    }
}
</script>

<style scoped>
    .pageManager-m{padding: 30px 0;}
    .jobMain{width: 80%; max-width: 1400px; margin: 0 auto;}
    @media (max-width: 1400px) and (min-width: 1300px) {
        .jobMain{width: 90%;  margin: 0 auto;}
    }
    @media (max-width: 1300px) {
        .jobMain{width: 100%; min-width: 1150px;}
    }
    .manager-rig{}
    .manager-rt{height: 42px; padding-bottom: 18px;}
    .manager-rtle{font-size: 24px; line-height: 40px; float: left; font-weight: bold;}
    .manager-rtr{height: 40px; float: right;}
    .manager-rm{border-radius: 10px; background: url("../assets/images/manager-rbg.png") no-repeat right top #fff; border: 1px solid #fef2f2; padding: 20px; margin-bottom: 24px;}
    .manager-rmt{display: flex; align-items: center; justify-content: space-between; min-height: 28px; line-height: 28px; margin-bottom: 24px; font-size: 16px; font-weight: bold;}
    .manager-rmt-title{padding-left: 10px; border-left: 3px solid #E7000B;}
    .manager-rmt-export{flex-shrink: 0; margin-left: 16px;}
    .manager-rmsubt{font-size: 12px; font-weight: normal; color: #99A1AF; padding-left: 24px;}

    .manager-tjbox{border-radius: 8px; background: #fff; border: 1px solid #F3F4F6; box-shadow: 0 5px 5px #F3F4F6; padding: 50px 20px; box-sizing: border-box; height: 200px;}
    .manager-tjbox--reviewed{padding: 20px;}
    .tjReviewedMain{display: flex; align-items: center; justify-content: space-between; width: 100%; height: 100%;}
    .tjReviewedLeft{flex-shrink: 0;}
    .tjBreakdown{margin-left: 12px; font-size: 12px; color: #6A7282; line-height: 22px; text-align: right; flex: 1;}
    .tjBreakdown span{display: block; white-space: nowrap;}
    .manager-tjbox1{border-radius: 8px; background: rgba(247,248,249,0.5); border: 1px solid #F3F4F6; box-shadow: 0 5px 5px #F3F4F6; padding: 10px; height: 180px;}
    .ficon{font-size: 24px;}
    .tjSubtle{font-size: 12px; color: #99A1AF; line-height: 30px;}
    .tjNum{font-size: 24px; line-height: 40px; font-weight: bold;}
    .blue{color: #409EFF;}
    .red{color: #E7000B;}
    .green{color: #67C23A;}
    .yellow{color: #E6A23C;}
</style>
